/**
 * The default work-order flow, for the views that render before
 * `GET /work-orders/flow` has answered.
 *
 * Mirrors `resolveFlowConfig(DEFAULT_FLOW_CONFIG)` in
 * services/staff-api/src/lib/work-order-flow-config.ts — keep the two in step.
 * `confirmed` is not a status any more (#534); listing it here made a chip
 * flash and vanish while the flow loaded (#2881).
 */

/** Enabled statuses in display order (enabledStatuses sorted by defaultSort). */
export const DEFAULT_FLOW_STATUS_KEYS: readonly string[] = [
  'quote',
  'quote_rejected',
  'pending',
  'vehicle_arrived',
  'in_progress',
  'paused',
  'work_completed',
  'ready_to_invoice',
  // Collecting consolidated invoice (#3941). Edges, owned by the flow API:
  // ready_to_invoice → on_consolidated_invoice on attach,
  // on_consolidated_invoice → invoiced when that invoice is sent,
  // on_consolidated_invoice → ready_to_invoice on detach.
  'on_consolidated_invoice',
  'invoiced',
  'completed',
  'cancelled',
];

/** Statuses with `isTerminal: true` in MASTER_STATUSES. */
export const DEFAULT_TERMINAL_STATUS_KEYS: ReadonlySet<string> = new Set([
  'completed',
  'cancelled',
  'quote_rejected',
]);

/** DEFAULT_FLOW_CONFIG.kanbanColumns. */
export const DEFAULT_KANBAN_COLUMNS: readonly string[] = [
  'quote',
  'pending',
  'vehicle_arrived',
  'in_progress',
  'paused',
  'work_completed',
  'ready_to_invoice',
  'on_consolidated_invoice',
  'invoiced',
  'completed',
  'cancelled',
];
